import { selectAll } from "../utils/utils";
import Swiper from 'swiper/bundle';

export class CustomTestimonials {
  constructor(el) {
    if (el) {
      this.init(el);
    }
  }

  init(el) {
    this.el = el;
    this.props();
    this.render();
  }

  props() {
    this.customTestimonialsContainer = selectAll("[data-blog-custom-testimonials]");
  }

  render() {
    this.customTestimonialsCarousel();
  }

  customTestimonialsCarousel = () => {
    for (var i = 0; i < this.customTestimonialsContainer.length; i++) {
      new Swiper(this.customTestimonialsContainer[i], {
        slidesPerView: 1.5,
        spaceBetween: 30,
        slidesOffsetBefore: 24,
        scrollbar: {
          el: '.swiper-scrollbar',
          draggable: true,
        },
        breakpoints: {
          991: {
            slidesPerView: 2.1,
            spaceBetween: 110,
            slidesOffsetBefore: 80,
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
          }
        }
      });
    }
  };
}
